document.addEventListener("DOMContentLoaded", async function () {
  console.log("🔄 Starting addtocart.js script...");

  const shopifyDomain = "bioelectricshield.myshopify.com";
  const storefrontAccessToken = "edd51681362c3a7502ff3d4e033b676c";
  const cartKey = "shopify_cart_id"; // For localStorage tracking

  const buyButtonContainer = document.getElementById("buy-button-container");
  if (!buyButtonContainer) {
    console.error("❌ ERROR: Buy button container not found in the DOM!");
    return;
  }
  
  const productId = buyButtonContainer.getAttribute("data-product-id");
  if (!productId) {
    console.error("❌ ERROR: Product ID not found in the DOM!");
    return;
  }
  console.log("✅ Found Product ID:", productId);
  
  // Construct product GID
  const productGid = `gid://shopify/Product/${productId}`;
  
  // GraphQL query to fetch product details with variants, options, images
  const query = `
    query getProduct($id: ID!) {
      product(id: $id) {
        id
        title
        options {
          name
          values
        }
        images(first: 5) {
          edges {
            node {
              src
            }
          }
        }
        variants(first: 100) {
          edges {
            node {
              id
              availableForSale
              priceV2 {
                amount
              }
              selectedOptions {
                name
                value
              }
              image {
                src
              }
            }
          }
        }
      }
    }
  `;
  
  const variables = { id: productGid };
  
  try {
    // Fetch product data from Shopify GraphQL API
    const response = await fetch(`https://${shopifyDomain}/api/2023-04/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
      },
      body: JSON.stringify({ query, variables }),
    });
    
    if (!response.ok) {
      throw new Error("Failed to fetch product data");
    }
    
    const result = await response.json();
    const product = result.data.product;
    if (!product) {
      console.error("❌ ERROR: No product data returned.");
      return;
    }
    
    // Process variants from GraphQL edges
    const variants = product.variants.edges.map(edge => edge.node);
    if (variants.length === 0) {
      console.error("❌ ERROR: No variants found for this product.");
      return;
    }
    
    // Use first image as default (if available)
    const defaultImage = product.images.edges.length > 0 ? product.images.edges[0].node.src : "";
    // Use first variant for defaults
    const defaultVariant = variants[0];
    
    // --- Build Availability Map ---
    // For each option name, record which values are available in at least one variant (availableForSale === true)
    const availabilityMap = {};
    product.options.forEach(option => {
      availabilityMap[option.name] = {};
      option.values.forEach(val => {
        availabilityMap[option.name][val] = false;
      });
    });
    variants.forEach(variant => {
      if (variant.availableForSale) {
        variant.selectedOptions.forEach(opt => {
          if (availabilityMap[opt.name] !== undefined) {
            availabilityMap[opt.name][opt.value] = true;
          }
        });
      }
    });
    console.log("Availability Map:", availabilityMap);
    const isDefaultProduct =
    product.options.length === 1 &&
    product.options[0].values.length === 1 &&
    product.options[0].values[0] === "Default Title";
    // --- Build Dropdowns ---
    let optionDropdowns = "";
    product.options.forEach((option, idx) => {
      optionDropdowns += `
        <label class="shopify-buy__option-select__label" for="option-${idx}">
          ${option.name}:
        </label><br />
        <select id="option-${idx}" class="shopify-buy__option" style="padding: 10px; margin: 5px 0 20px 0px;">`;
      option.values.forEach(value => {
        const disabledAttr = availabilityMap[option.name][value] ? "" : ' disabled style="color:gray;"';
        optionDropdowns += `<option value="${value}"${disabledAttr}>${value}</option>`;
      });
      optionDropdowns += `</select><br />`;
    });
    
    // Add a div to display stock status messages
    const stockMessageHTML = `<div id="stock-message" style="color:white; margin-bottom:10px;font-weight:bold;"></div>`;
    
    // --- Render Product Details ---
    buyButtonContainer.innerHTML = `
    <div class="has-image shopify-buy__layout-vertical shopify-buy__product">
      <div class="shopify-buy__product-img-wrapper">
        <img id="product-img" src="${defaultVariant.image?.src || defaultImage}" 
             alt="${product.title}" style="width: 100%; object-fit: contain;" crossorigin="anonymous" />
      </div>
      <div class="shopify-buy__product-info-wrapper">
        <div class="shopify-buy__product-info-inner">
          <h1 class="shopify-buy__product__title">${product.title}</h1>
          <div class="shopify-buy__product__price">$${parseFloat(defaultVariant.priceV2.amount).toFixed(2)}</div>
          <div class="shopify-buy__product__variant-selectors" ${isDefaultProduct ? 'style="display:none;"' : ''}>
            ${
              !isDefaultProduct
                ? `<div class="shopify-buy__option-select">
                    ${optionDropdowns}
                  </div>`
                : ""
            }
            ${stockMessageHTML}
          </div>
        </div>
        <button id="add-to-cart-btn" class="shopify-buy__btn" data-variant-id="${defaultVariant.id}" style="opacity:1;">
          Add to Cart
        </button>
      </div>
    </div>
  `;
    
    // --- References for Updates ---
  // --- References for Updates ---
const productImg = document.getElementById("product-img");
const addToCartBtn = document.getElementById("add-to-cart-btn");
const stockMessageDiv = document.getElementById("stock-message");

if (!isDefaultProduct) {
  const variantSelectElements = document.querySelectorAll(".shopify-buy__option");
  // --- Helper Function: getCurrentSelections ---
  function getCurrentSelections() {
    const selections = {};
    product.options.forEach((option, idx) => {
      selections[option.name] = variantSelectElements[idx].value;
    });
    return selections;
  }
  function updateFloatingCartCount(count) {
  const tryUpdate = () => {
    const el = document.querySelector('.cartcount');
    if (el) {
      el.textContent = count;
      console.log('✅ Updated .cartcount to', count);
    } else {
      console.warn('❌ .cartcount not found – retrying...');
    }
  };

  tryUpdate();
  setTimeout(tryUpdate, 300);
  setTimeout(tryUpdate, 1000);
}
  // --- Update Variant Details ---
  function updateVariantDetails() {
    const selectedOptions = Array.from(variantSelectElements).map(s => s.value);
    const matchingVariant = variants.find(variant =>
      variant.selectedOptions.every((opt, idx) => opt.value === selectedOptions[idx])
    );
    if (matchingVariant && matchingVariant.availableForSale) {
      productImg.src = matchingVariant.image?.src || defaultImage;
      const priceContainer = document.querySelector(".shopify-buy__product__price");
      if (priceContainer) {
        priceContainer.textContent = `$${parseFloat(matchingVariant.priceV2.amount).toFixed(2)}`;
      }
      addToCartBtn.setAttribute("data-variant-id", matchingVariant.id);
      addToCartBtn.disabled = false;
      addToCartBtn.style.opacity = "1";
      stockMessageDiv.textContent = "";
    } else {
      console.warn("No matching available variant found.");
      addToCartBtn.disabled = true;
      addToCartBtn.style.opacity = "0.5";
      stockMessageDiv.textContent = "Sorry, this combination is temporarily out of stock.";
    }
  }
  
  // Attach change event listeners to dropdowns
  variantSelectElements.forEach(select => {
    select.addEventListener("change", updateVariantDetails);
  });
  
  // Initial update
  updateVariantDetails();
  
} else {
  // For default products, simply update the stock message based on defaultVariant availability.
  if (!defaultVariant.availableForSale) {
    stockMessageDiv.textContent = "Sorry, this product is out of stock.";
    addToCartBtn.disabled = true;
    addToCartBtn.style.opacity = "0.5";
  }
}
    
    // --- Add to Cart Handler ---
    addToCartBtn.addEventListener("click", async function () {
      console.log("Add-to-cart button clicked");

      let matchingVariant;
      if (!isDefaultProduct) {
        // For products with variants, get the current selections.
        const variantSelectElements = document.querySelectorAll(".shopify-buy__option");
        const selectedOptions = Array.from(variantSelectElements).map(s => s.value);
        console.log("✅ Selected Options:", selectedOptions);
        matchingVariant = variants.find(variant =>
          variant.selectedOptions.every((opt, idx) => opt.value === selectedOptions[idx])
        );
      } else {
        // For default products, use the default variant.
        matchingVariant = defaultVariant;
      }
      
      if (!matchingVariant || !matchingVariant.availableForSale) {
        alert("This variant combination is not available.");
        console.error("❌ ERROR: No matching available variant found.");
        return;
      }
      console.log("🛍️ Adding product to cart:", matchingVariant.id);
      
      let existingCartId = localStorage.getItem(cartKey);
      let mutationQuery = "";
      let variables = {};
      
      if (!existingCartId) {
        mutationQuery = `
          mutation cartCreate($merchId: ID!) {
            cartCreate(input: {
              lines: [{ quantity: 1, merchandiseId: $merchId }]
            }) {
              cart { id checkoutUrl totalQuantity }
              userErrors { field message }
            }
          }
        `;
        variables = { merchId: matchingVariant.id };
      } else {
        mutationQuery = `
          mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
            cartLinesAdd(cartId: $cartId, lines: $lines) {
              cart { id checkoutUrl totalQuantity }
              userErrors { field message }
            }
          }
        `;
        variables = {
          cartId: existingCartId,
          lines: [{ quantity: 1, merchandiseId: matchingVariant.id }]
        };
      }
      
      try {
        const response = await fetch(`https://${shopifyDomain}/api/2023-04/graphql.json`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
          },
          body: JSON.stringify({ query: mutationQuery, variables }),
        });
        if (!response.ok) throw new Error("Failed to add item to cart");
        const result = await response.json();
        console.log("✅ GraphQL cart mutation result:", result);
        let newCart;
        if (result.data.cartCreate) {
          newCart = result.data.cartCreate.cart;
        } else if (result.data.cartLinesAdd) {
          newCart = result.data.cartLinesAdd.cart;
        }
    if (newCart && newCart.id) {
  localStorage.setItem(cartKey, newCart.id);
}

if (newCart?.totalQuantity !== undefined) {
  updateFloatingCartCount(newCart.totalQuantity);
}

if (window.fetchCart) window.fetchCart();
if (window.openCart) window.openCart();
      } catch (error) {
        console.error("❌ ERROR adding product to cart:", error);
      }
    });
    
    // Initial update
    if (!isDefaultProduct) {
      updateVariantDetails();
    }    
  } catch (error) {
    console.error("❌ ERROR fetching product details:", error);
  }
  
});